// Shared expand icon (corner arrows, matches summary1 mockup)
const ExpandIcon = () => (
  <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor"
       strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 9 3 13 7 13" />
    <polyline points="13 7 13 3 9 3" />
    <line x1="3" y1="13" x2="7" y2="9" />
    <line x1="13" y1="3" x2="9" y2="7" />
  </svg>
);

export default ExpandIcon;
